export default __webpack_public_path__ + "static/media/ellipse_mission.74803eae.svg";